export const bottomCouplesLocationSharingFeatures = [
    {
        id: '1',
        title: 'Know They’re Safe Without Asking',
        content: 'No need to check whether they got to work okay, or when they’re on their way home, the app tells you automatically.',
        imgName: 'earth'
    },
    {
        id: '2',
        title: 'Find Each Other Easily in Busy Places',
        content: "No more struggling to meet up, you can see exactly where they are at concerts, malls, or events.",
        imgName: 'checkCircleIcon'
    },
    {
        id: '3',
        title: 'Fewer Worrying Moments',
        content: "If they’re not answering their phone, you’ll know where they are, and how much battery they have, so you can save time stressing.",
        imgName: 'mobilePhoneIcon'
    },
    {
        id: '4',
        title: 'Reassuring, Not Overbearing',
        content: "Device Tracker Plus isn’t an app for surveillance, it’s to keep you connected and organised. You both share locations openly, with trust.",
        imgName: 'eye'
    },
];